import React, { useEffect } from "react";
import PropTypes from "prop-types";
import EventBus from "js-event-bus";
import { EVENT_BUS_EVENTS } from "../../utils/useEventBus";
import apiService from "../../utils/ApiService";

const TokenEventService = ({ eventBus }) => {
  useEffect(() => {
    const handler = async (context) => {
      const { consumer, url, requestId } = context;
      try {
        const { data } = await apiService.getTokenizedUrl(consumer, url);
        eventBus.emit(EVENT_BUS_EVENTS.RECEIVE_TOKENIZED_URL, null, {
          requestId,
          response: data
        });
      } catch (e) {
        eventBus.emit(EVENT_BUS_EVENTS.RECEIVE_TOKENIZED_URL, null, {
          requestId,
          error: e.message
        });
        window.DD_RUM.addError(`Token Event Service Error: ${e.message}`, {
          scope: "mfe-container",
          team: "cd.ghostriders",
          component: "TokenEventService"
        });
      }
    };
    eventBus.on(EVENT_BUS_EVENTS.FETCH_TOKENIZED_URL, handler);
    return () => eventBus.detach(EVENT_BUS_EVENTS.FETCH_TOKENIZED_URL, handler);
  }, [eventBus]);

  return <></>;
};

TokenEventService.propTypes = {
  eventBus: PropTypes.object
};

export default TokenEventService;
